import { Component, Input, OnInit } from '@angular/core';
import { TransactionService } from '../../../Services/transaction.service';
import { PaymentAgingParam } from '../../../Models/searchCustomer';
import { MatTableDataSource } from '@angular/material/table';
import { CookieService } from 'ngx-cookie-service';
import { Utility } from '../../../Utilities/utility';
import { MasterService } from 'src/app/Services/master.service';

@Component({
  selector: 'app-customer-ageing',
  templateUrl: './customer-ageing.component.html',
  styleUrls: ['./customer-ageing.component.css']
})
export class CustomerAgeingComponent implements OnInit {
  @Input() paymentAgingParam: PaymentAgingParam;
  dataSource = new MatTableDataSource<any>();
  collectionDays: any;
  utility: Utility;
  public ageing: any;
  public ageingHeader: string[] = ["days30", "days60", "days90", "days120", "more120days", "CrAmt", "TotalAmt"];
  constructor(
    private _TransactionService: TransactionService,
    private _MasterService: MasterService,
    private cookieService: CookieService
  ) {
    this.paymentAgingParam = new PaymentAgingParam();
    this.utility = new Utility(this.cookieService);
  }

  ngOnInit(): void {

    this.BindAgeingDetail();
  }


  BindAgeingDetail(){
    if (this.paymentAgingParam.officeId != undefined && this.paymentAgingParam.officeId > 0 && this.paymentAgingParam.saleCode != undefined) {
      this._TransactionService.GetPaymentAging(this.paymentAgingParam).subscribe((d: any) => {
        if (d) {
                    this.dataSource.data = d;
        }
      }, (error) => {                              //Error callback
        this.utility.Error(error);
      });
    }
    if (this.paymentAgingParam.CompanyId != undefined){
      this._MasterService.GetCollectionDaysBycompanyId(this.paymentAgingParam.CompanyId).subscribe((d:any)=>{
        if(d){
          this.ageing = d;
        }
      });
    }

    
  }

 


}
